export default __webpack_public_path__ + "static/media/T860_RoHS.1c3ab552.pdf";